import type { NavConfig } from '@/types/nav-config';
import { participantNavConfig } from './participant.nav';
import { adminNavConfig } from './admin.nav';

export interface NavRouteOption {
    /** Route name, as used in routes.ts / router.push({ name }). */
    name: string;
    /** i18n key for this route's label — reuses the same key its sidenav entry uses. */
    labelKey: string;
}

/** Flattens a NavConfig into its individual link routes (group children included, groups/headings/dividers excluded). */
function extractLinkRoutes(config: NavConfig): NavRouteOption[] {
    const routes: NavRouteOption[] = [];
    for (const item of config) {
        if (item.type === 'link') {
            routes.push({ name: item.route, labelKey: item.labelKey });
        } else if (item.type === 'group') {
            for (const child of item.children) {
                routes.push({ name: child.route, labelKey: child.labelKey });
            }
        }
    }
    return routes;
}

// Every route selectable in the participant/admin sidenav — the universe an organization can
// restrict access to via metadata.navigation.allowedParticipantRoutes / allowedAdminRoutes.
export const PARTICIPANT_NAV_ROUTES: NavRouteOption[] = extractLinkRoutes(participantNavConfig);
export const ADMIN_NAV_ROUTES: NavRouteOption[] = extractLinkRoutes(adminNavConfig);
